"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";
import {
  TrackingEventID,
  TrackingEventType,
  TrackingEventPageID,
} from "@/shared";
import { useTrack } from "@/hooks/useTrack";
import { getUriQuery } from "@/utils/url";
import { buildTrackingEventData } from "@/utils/tenjin";
import { clientWindow } from "@/utils/dom";

export default function PageEntryTracker() {
  const pathname = usePathname();
  const { tracking } = useTrack();

  useEffect(() => {
    const urlStr = clientWindow?.location?.search || "";
    const queryData = getUriQuery(urlStr);
    const hasIParam = queryData?.i;

    if (hasIParam) {
      const trackingData = buildTrackingEventData(queryData);

      tracking({
        event_id: TrackingEventID.Download,
        event_type: TrackingEventType.Exposure,
        page_id: TrackingEventPageID.DownloadPage,
        path: pathname,
        ...trackingData,
      });
    }

    tracking({
      event_id: TrackingEventID.PageFirstEnter,
      event_type: TrackingEventType.Exposure,
      path: pathname,
    });
  }, [pathname, tracking]);

  return null;
}
